export default function HealthResourcesController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  confirmDialog,
  editHealthResourcesDialog,
  loaderService,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.canExpand = true;
  vm.hasData = false;
  vm.handleExpand = _handleExpand;
  vm.handleAdd = _handleAdd;
  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadResources();
    }
    return Promise.resolve();
  }

  function _handleAdd($event) {
    return _showDialog($event, {
      healthResource: { // New record
        assessmentId: vm.assessmentId,
        assessmentHealthResourceId: 0,
        resourceInformation: '',
        contactNumber: '',
      },
    });
  }

  function _handleEdit($event, resource) {
    return _showDialog($event, {
      healthResource: resource,
    });
  }

  function _handleDelete($event, resource) {
    ssDialogService.dialogs.bcp.confirmDeleteHealthResourceDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Health Resource?',
        message: `Are you sure you want to delete the Health Resource "${resource.name}"?`,
        handleYesClick() {
          _deleteResource(resource.assessmentHealthResourceId);
        },
        handleNoClick: _closeConfirmDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteHealthResourceDialog);
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('refreshBCPHealthResource', _loadResources);
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _loadResources() {
    loaderService.showViewLoader = true;
    return bcpDataService.getHealthResources(vm.assessmentId)
      .then((getHealthResourcesResponse) => {
        loaderService.showViewLoader = false;
        vm.healthResources = getHealthResourcesResponse.data.result;
        vm.hasData = true;
      });
  }

  function _deleteResource(resourceId) {
    loaderService.showViewLoader = true;
    return bcpDataService.deleteHealthResource(resourceId)
      .then(() => {
        alerts.success('The Health Resource has been deleted successfully.');
        $rootScope.$broadcast('refreshBCPHealthResource');
        $rootScope.$broadcast('setDocumentRegenerateFlag');
        _closeDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting Health Resource.');
      }).finally(() => {
        loaderService.showViewLoader = false;
        return _closeConfirmDeleteDialog();
      });
  }

  function _showDialog($event, locals) {
    ssDialogService.dialogs.bcp.editHealthResourcesDialog = ssDialogService.alert(
      editHealthResourcesDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editHealthResourcesDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editHealthResourcesDialog);
  }

  function _closeConfirmDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteHealthResourceDialog);
  }
}

HealthResourcesController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'confirmDialog',
  'editHealthResourcesDialog',
  'loaderService',
  'ssDialogService',
  'userService'
];
